
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1j5kh_32",
  "input": "awsui_input_2rhyz_1j5kh_36",
  "input-readonly": "awsui_input-readonly_2rhyz_1j5kh_89",
  "input-invalid": "awsui_input-invalid_2rhyz_1j5kh_122",
  "input-warning": "awsui_input-warning_2rhyz_1j5kh_125",
  "input-type-search": "awsui_input-type-search_2rhyz_1j5kh_128",
  "input-has-icon-start": "awsui_input-has-icon-start_2rhyz_1j5kh_138",
  "input-has-icon-end": "awsui_input-has-icon-end_2rhyz_1j5kh_141",
  "input-container": "awsui_input-container_2rhyz_1j5kh_145",
  "input-field": "awsui_input-field_2rhyz_1j5kh_150",
  "input-field-readonly": "awsui_input-field-readonly_2rhyz_1j5kh_174",
  "input-field-disabled": "awsui_input-field-disabled_2rhyz_1j5kh_189",
  "input-field-invalid": "awsui_input-field-invalid_2rhyz_1j5kh_197",
  "input-field-warning": "awsui_input-field-warning_2rhyz_1j5kh_211",
  "input-field-no-border-radius": "awsui_input-field-no-border-radius_2rhyz_1j5kh_225",
  "input-field-no-border": "awsui_input-field-no-border_2rhyz_1j5kh_225",
  "grouped": "awsui_grouped_2rhyz_1j5kh_240",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_2rhyz_1j5kh_247",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_2rhyz_1j5kh_251",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_2rhyz_1j5kh_257",
  "grouped-vertical-first": "awsui_grouped-vertical-first_2rhyz_1j5kh_261",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_2rhyz_1j5kh_265",
  "grouped-vertical-last": "awsui_grouped-vertical-last_2rhyz_1j5kh_271",
  "grouped-with-action": "awsui_grouped-with-action_2rhyz_1j5kh_275",
  "grouped-with-error": "awsui_grouped-with-error_2rhyz_1j5kh_279",
  "grouped-horizontal-only": "awsui_grouped-horizontal-only_2rhyz_1j5kh_307",
  "grouped-vertical-only": "awsui_grouped-vertical-only_2rhyz_1j5kh_307",
  "grouped-with-warning": "awsui_grouped-with-warning_2rhyz_1j5kh_313",
  "grouped-vertical": "awsui_grouped-vertical_2rhyz_1j5kh_261",
  "grouped-horizontal": "awsui_grouped-horizontal_2rhyz_1j5kh_247",
  "input-prefix": "awsui_input-prefix_2rhyz_1j5kh_374",
  "input-suffix": "awsui_input-suffix_2rhyz_1j5kh_375",
  "input-adornment-content": "awsui_input-adornment-content_2rhyz_1j5kh_389",
  "input-adornment-divider": "awsui_input-adornment-divider_2rhyz_1j5kh_398",
  "input-icon-start": "awsui_input-icon-start_2rhyz_1j5kh_424",
  "input-icon-start-disabled": "awsui_input-icon-start-disabled_2rhyz_1j5kh_431",
  "input-icon-end": "awsui_input-icon-end_2rhyz_1j5kh_435",
  "input-button-right": "awsui_input-button-right_2rhyz_1j5kh_441",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_2rhyz_1j5kh_445",
  "inline-label-trigger-wrapper-full-width": "awsui_inline-label-trigger-wrapper-full-width_2rhyz_1j5kh_448",
  "inline-label-wrapper": "awsui_inline-label-wrapper_2rhyz_1j5kh_452",
  "inline-label-wrapper-full-width": "awsui_inline-label-wrapper-full-width_2rhyz_1j5kh_455",
  "inline-label": "awsui_inline-label_2rhyz_1j5kh_445",
  "inline-label-disabled": "awsui_inline-label-disabled_2rhyz_1j5kh_480"
};
  